import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { convertDateToNgbDateStruct, getDayJsFromNgbDateStruct } from '@mwe/utils';

dayjs.extend(customParseFormat);

const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD';
const DEFULT_DATE_VIEW_FORMAT = 'DD.MM.YYYY';

function isValidNgbDateStruct(date: NgbDateStruct | null | undefined): date is NgbDateStruct {
  return !!date && dayjs(`${date.year}-${date.month}-${date.day}`, 'YYYY-M-D', true).isValid();
}

export function mapDateStringToDayjs(date: string, sourceFormat = DEFAULT_DATE_FORMAT): Dayjs | null {
  if (!date?.trim()) {
    return null;
  }

  const parsedDate = dayjs(date.trim(), sourceFormat, true);
  return parsedDate.isValid() ? parsedDate : null;
}

export function mapDateStringToNgbDateStruct(date: string | null | undefined, sourceFormat = DEFAULT_DATE_FORMAT): NgbDateStruct | null {
  const parsedDate = mapDateStringToDayjs(date, sourceFormat);
  return parsedDate ? convertDateToNgbDateStruct(parsedDate) : null;
}

export function mapOffsetDateTimeStringToDisplayDate(date: string | null | undefined): string | null {
  const datePart = date?.split('T')[0] ?? date;
  const parsedDate = mapDateStringToDayjs(datePart);

  return parsedDate ? parsedDate.format(DEFULT_DATE_VIEW_FORMAT) : null;
}

export function mapNgbDateStructToDateString(date: NgbDateStruct | null | undefined, targetFormat = DEFAULT_DATE_FORMAT): string | null {
  if (!isValidNgbDateStruct(date)) {
    return null;
  }

  const dayjsDate = getDayJsFromNgbDateStruct(date ?? null);
  return dayjsDate?.isValid() ? dayjsDate.format(targetFormat) : null;
}
